import React, { useRef, useEffect, useState } from "react";
import "./Map.scss";
import { useLocation } from "react-router-dom";
import ReactMapGL, {
  GeolocateControl,
  Marker,
  NavigationControl,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Pin from "../../assets/icons/placeholder.svg";

const TOKEN =
  "pk.eyJ1IjoiYmlvbWFuaWFjayIsImEiOiJja2dyMDZ6N3YwOWFuMnhtZnZpanVoZHdhIn0.FXRFlQ2eIA4CzwHZu8pA1w";

const Map = () => {
  const location = useLocation();
  const [viewport, setViewPort] = useState({
    width: "fit",
    height: "100%",
    latitude: 50.8160666,
    longitude: 4.359065,
    zoom: 13,
  });

  const _onViewportChange = (viewport) =>
    setViewPort({ ...viewport, transitionDuration: 300 });

  return (
    <div id="map" className="map-bottom" name="firstInsideContainer">
      <ReactMapGL
        className="mapContainer"
        {...viewport}
        mapboxApiAccessToken={TOKEN}
        mapStyle="mapbox://styles/mapbox/light-v10"
        onViewportChange={_onViewportChange}
      >
        {/* <GeolocateControl
          style={geolocateStyle}
          positionOptions={{ enableHighAccuracy: true }}
          trackUserLocation={true}
        /> */}
        <div style={{ position: "absolute", right: 0 }}>
          <NavigationControl />
        </div>
        {location.pathname == "/fox-brugmann" && (
          <Marker
            latitude={50.8160666}
            longitude={4.359065}
            offsetLeft={-20}
            offsetTop={-10}
          >
            <img src={Pin} style={{ width: "50px" }}></img>
          </Marker>
        )}
        {location.pathname == "/fox-latins" && (
          <Marker
            latitude={50.8137462}
            longitude={4.3851896}
            offsetLeft={-20}
            offsetTop={-10}
          >
            <img src={Pin} style={{ width: "50px" }}></img>
          </Marker>
        )}
        {location.pathname == "/fox-university" && (
          <Marker
            latitude={50.8151828}
            longitude={4.3862857}
            offsetLeft={-20}
            offsetTop={-10}
          >
            <img src={Pin} style={{ width: "50px" }}></img>
          </Marker>
        )}
        {location.pathname == "/fox-washington" && (
          <Marker
            latitude={50.8225579}
            longitude={4.3629071}
            offsetLeft={-20}
            offsetTop={-10}
          >
            <img src={Pin} style={{ width: "50px" }}></img>
          </Marker>
        )}
        {location.pathname == "/fox-churchill" && (
          <Marker
            latitude={50.8117514}
            longitude={4.3654363}
            offsetLeft={-20}
            offsetTop={-10}
          >
            <img src={Pin} style={{ width: "50px" }}></img>
          </Marker>
        )}
      </ReactMapGL>
      )
    </div>
  );
};

export default Map;
